import { BaseService } from './base.service';
import { SystemSettingsDTO } from '../model/SystemSettingsDTO';

export class SystemService extends BaseService {
	async fetchTimeVersion(): Promise<number> {
		return this.fetch<number>(`/api/system/time-version`);
	}

	async fetchSettings(): Promise<SystemSettingsDTO> {
		return this.fetch<SystemSettingsDTO>(`/api/system/settings`);
	}
}
